import programmaticPlayerRender from '@embed/programmaticPlayerRender';
export function fwnPlay(w) {
    let element = undefined;
    return function (attrs, opts = {}) {
        if (element) {
            element.remove();
        }
        element = document.createElement('div');
        (w.document.body || w.document.head).appendChild(element);
        programmaticPlayerRender(Object.assign(Object.assign({}, attrs), { target: element }), opts);
    };
}
